module.exports = __webpack_public_path__ + "img/gcb.ad155733.jpg";